import script from "./customerMap.vue?vue&type=script&setup=true&lang=js"
export * from "./customerMap.vue?vue&type=script&setup=true&lang=js"

import "./customerMap.vue?vue&type=style&index=0&id=2dccb666&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2dccb666"]])

export default __exports__